/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade, Keyboard, Mousewheel } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/freedom_bank_texas_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
// Swiper.use([Navigation, Pagination])
Swiper.use([Pagination, Autoplay, Navigation, EffectFade, Keyboard, Mousewheel]);
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//


	const modal = document.getElementById('appointmentModal');
	/* OPEN MODAL */
	document.querySelectorAll('[data-open-appointment]').forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();
			modal.classList.add('is-open');
		});
	});

	/* CLOSE ON OVERLAY / CLOSE BUTTON */
	modal.addEventListener('click', e => {
		if (
			e.target.classList.contains('custom-modal__overlay') ||
			e.target.classList.contains('custom-modal__close')
		) {
			modal.classList.remove('is-open');
		}
	});

	/* CLOSE AFTER CF7 SUBMIT */
	document.addEventListener('wpcf7mailsent', event => {
		const modal = document.getElementById('appointmentModal');
		modal.classList.remove('is-open');
	});


	const heroSwiper = new Swiper('.heroSwiper', {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		loop: true,
		speed: 800,
		// effect: 'fade',
		// fadeEffect: {
		//   crossFade: true
		// },
		autoplay: {
			delay: 10000,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.hero-swiper-button-next',
			prevEl: '.hero-swiper-button-prev',
		},
		pagination: {
			el: '.heroSwiper .swiper-pagination',
			clickable: true,
		},
	});


	const freedomSwiper = new Swiper('.freedomSwiper', {
		centeredSlides: true,
		slidesPerView: 1,
		spaceBetween: 20,
		centeredSlides: true,
		loop: true,
		// initialSlide: 3, 
		// speed: 600,
		// autoplay: {
		//   delay: 4000,
		//   disableOnInteraction: false,
		//   pauseOnMouseEnter: true,
		// },

		// Pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		// Breakpoints
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
				initialSlide: 0,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
				initialSlide: 0,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 25,
				initialSlide: 1,
			},
			1440: {
				slidesPerView: 3,
				spaceBetween: 30,
				initialSlide: 1,
			},
		},
	});


});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */